import React from 'react';
import { View, Text, StyleSheet } from 'react-native';

import { Button, ButtonTypes } from '../../components';
import Theme from '../../theme';
import { ExclamationIcon } from '../../ui';

const AcceptSettingsFooter = ({ t, back, acceptSettings, acceptIsLoading = false , containerStyle = null}) => (
  <View style={containerStyle}>
    <View style={styles.infoContainer}>
      <ExclamationIcon size={35} />
      <Text style={styles.info}>{t('customisedConflictWithGoals')}</Text>
    </View>
    <View style={styles.buttonsContainer}>
      <Button
        title={t('back')}
        buttonType={ButtonTypes.OUTLINE}
        fontColor={Theme.PRIMARY}
        onPress={back}
        containerStyle={[styles.buttonContainer, styles.buttonMargin]}
      />
      <Button
        title={t('accept')}
        buttonType={ButtonTypes.NORMAL}
        fontColor={Theme.WHITE}
        onPress={acceptSettings}
        containerStyle={styles.buttonContainer}
        isLoading={acceptIsLoading}
      />
    </View>
  </View>
);

const styles = StyleSheet.create({
  infoContainer: {
    paddingBottom: 10,
    flexDirection: 'row',
    alignItems: 'center',
  },
  info: {
    flex: 1,
    paddingLeft: 10,
    fontSize: 14,
    color: Theme.GREY_DARK,
    fontFamily: Theme.Custom300,
  },
  buttonsContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  buttonContainer: {
    flex: 1,
  },
  buttonMargin: {
    marginRight: 5,
  }
})

export default AcceptSettingsFooter;
